export default __webpack_public_path__ + "static/media/gallery_07.8e465e23.jpg";